import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
//
//
//
//
//
//
//
//
//
//
import { getList as _getList, getObj, addObj, delObj, updateObj } from '@/api/bigscreen/category';
export default {
  data: function data() {
    return {
      form: {},
      data: [],
      option: {
        index: true,
        align: 'center',
        headerAlign: 'center',
        column: [{
          label: '模块名',
          prop: 'categoryKey',
          rules: [{
            required: true,
            message: "请输入模块名",
            trigger: "blur"
          }]
        }, {
          label: '模块值',
          prop: 'categoryValue',
          rules: [{
            required: true,
            message: "请输入模块值",
            trigger: "blur"
          }]
        }]
      }
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    vaildData: function vaildData(id) {
      return [0, 1].includes(id);
    },
    beforeOpen: function beforeOpen(done, type) {
      var _this = this;

      if (type == 'edit') {
        getObj(this.form.id).then(function (res) {
          var data = res.data.data;
          _this.form = data;
          done();
        });
      } else {
        done();
      }
    },
    rowDel: function rowDel(row, index) {
      var _this2 = this;

      if (this.vaildData(index)) {
        this.$message.error('例子模板不允许修改');
        return false;
      }

      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        delObj(row.id).then(function () {
          _this2.$message.success('删除成功');

          _this2.getList();
        });
      }).catch(function () {});
    },
    rowUpdate: function rowUpdate(row, index, done) {
      var _this3 = this;

      if (this.vaildData(index)) {
        this.$message.error('例子模板不允许修改');
        return false;
      }

      updateObj(row).then(function () {
        _this3.$message.success('修改成功');

        _this3.getList();

        done();
      });
    },
    rowSave: function rowSave(row, done) {
      var _this4 = this;

      addObj(row).then(function () {
        _this4.$message.success('新增成功');

        _this4.getList();

        done();
      });
    },
    getList: function getList() {
      var _this5 = this;

      _getList({
        current: 1,
        size: 100
      }).then(function (res) {
        var data = res.data.data;
        _this5.data = data;
      });
    }
  }
};